import React, { FC, HTMLAttributes } from "react";
import { ElFaqs, ElFaqsContent, ElColumn, elGapFaqs } from "./faq.css";
import { Container } from "../../layout";
import { Icons } from "../../icons";
import { cx } from "@linaria/core";
import { elFlexColumn } from "../../../@css-style";
import { Accordion } from "../../layout/accordion";
import { ElHeadLine } from "../head-title";

interface IFaqsProps extends HTMLAttributes<HTMLElement> {
  data: { title: string; desc: string }[];
}

export const Faqs: FC<IFaqsProps> = ({ children, data, ...props }) => {
  return (
    <ElFaqs {...props}>
      <Container className={elGapFaqs}>
        <ElFaqsContent>
          <ElHeadLine>Frequently Ask Questions</ElHeadLine>
          <ElColumn className={elFlexColumn}>
            <Accordion data={data} />
          </ElColumn>
        </ElFaqsContent>
      </Container>
    </ElFaqs>
  );
};
